function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFont22 = function SvgFont22(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.711,
    height: 16.038
  }, props), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25805",
    d: "M1.365 1.485a3.238 3.238 0 0 1 .506-1.779A3.2 3.2 0 0 1 3.281-1.5a21.557 21.557 0 0 0-2.819-.491 6.053 6.053 0 0 1 .931-3.243 6.026 6.026 0 0 1 2.517-2.19A8.393 8.393 0 0 1 7.605-8.2a7.888 7.888 0 0 1 3.435.712 5.488 5.488 0 0 1 2.313 1.984 5.307 5.307 0 0 1 .821 2.942v10.4h-3.5V-2.183a3.2 3.2 0 0 0-.92-2.367 3.274 3.274 0 0 0-2.422-.917 4.779 4.779 0 0 0-2.285.547A2.852 2.852 0 0 0 3.664-3.5a14.433 14.433 0 0 1 1.765.5 6.6 6.6 0 0 1 1.409.657v.985A3.106 3.106 0 0 0 5.375-.322a2.684 2.684 0 0 0-.507 1.642v6.514h-3.5z",
    transform: "translate(-.463 8.204)",
    style: {
      fill: "currentColor"
    }
  }));
};

export default SvgFont22;